/** Page views on arm, history changes, and back/forward. Hash-only changes are ignored. */

let installed = false;
let lastPath = "";

export function installPageViews(onPathChange: () => void): void {
  if (installed) return;
  installed = true;
  lastPath = window.location.pathname;

  const originalPush = history.pushState.bind(history);
  history.pushState = function (data, unused, url) {
    originalPush(data, unused, url);
    consider(onPathChange);
  };

  const originalReplace = history.replaceState.bind(history);
  history.replaceState = function (data, unused, url) {
    originalReplace(data, unused, url);
    consider(onPathChange);
  };

  window.addEventListener("popstate", () => consider(onPathChange));
}

function consider(onPathChange: () => void): void {
  if (window.location.pathname === lastPath) return;
  lastPath = window.location.pathname;
  onPathChange();
}
